module.exports = __webpack_public_path__ + "static/media/mosk_medium_500-webfont.e8922e0c.woff";